var render = function (_h,_vm) {
var _obj;
var _c=_vm._c;return _c('div',[(_vm.props.length > 1)?_c('v-pagination',{class:Object.assign({}, _vm.data.class, ( _obj = {}, _obj[_vm.data.staticClass] = true, _obj ), {pagination: true}),attrs:{"length":_vm.props.length,"total-visible":_vm.parent.$vuetify.breakpoint.xsOnly ? _vm.props.totalVisibleXs : _vm.props.totalVisible,"value":_vm.props.value},on:{"input":_vm.listeners.input}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }